import { PermissionsState } from "./permission.types";

export const state: PermissionsState = {
  userPermissions: null
};
